import React, { useState, useEffect } from "react";
import {
    ButtonOutline,
    ButtonSolid,
    Heading,
    TableWarpper,
    Text,
} from "../styledConstants";
import Pagination from "../../components/common/Pagination";
import {
    Box,
    CircularProgress,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    TextField,
    FormControlLabel,
    Switch,
} from "@mui/material";
import ApiRequest from "../../utils/ApiRequest";
import FilterBox from "../../components/common/FilterBox";
import { getParams } from "../../utils/common";
import { FilterWrapper } from "../../Pages/Merchants/style";
import Modal from "react-modal";
import MaterialInput from "../common/UI/MaterialInput";
import IconEdit from "../../assets/images/IconEdit";
import IcondDelete from "../../assets/images/delete.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../utils/config";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        minWidth: "350px",
    },
};

const filterForm = [
    { name: "tid", type: "text", value: "", placeholder: "TID" },
    { name: "orgCode", type: "text", value: "", placeholder: "Org Code" },
    {
        name: "active",
        type: "select",
        value: "",
        placeholder: "Status",
        options: [
            { label: "All", value: "" },
            { label: "Active", value: "true" },
            { label: "Inactive", value: "false" },
        ],
    },
];

const editValidationSchema = Yup.object().shape({
    tid: Yup.string()
        .matches(/^[A-Za-z0-9]+$/, "Only alphanumeric characters allowed")
        .max(50, "TID must be less than 50 characters")
        .required("TID is required"),

    orgCode: Yup.string()
        .matches(/^[A-Za-z0-9]+$/, "Only alphanumeric characters allowed")
        .max(50, "Org Code must be less than 50 characters")
        .required("Org Code is required"),
});

function TidWhitelistingTable({ refresh, setDownloadPayload }) {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [controls, setControls] = useState([...filterForm]);
    const [sortBy, setSortBy] = useState("createdAt");
    const [sortDirection, setSortDirection] = useState("DESC");
    const [selectedItem, setSelectedItem] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [editLimitReached, setEditLimitReached] = useState({
        tid: false,
        orgCode: false,
    });

    useEffect(() => {
        const reset = filterForm.map((filter) => ({
            ...filter,
            value: "",
        }));
        setControls(reset);
    }, []);

    const FilterChangeHandler = (event, index) => {
        const updatedControls = [...controls];
        let value = event?.target ? event.target.value : event;

        if (typeof value === "string") {
            const maxLength = 50;
            if (value.length > maxLength) {
                value = value.slice(0, maxLength);
                toast.warning("Maximum 50 characters allowed");
            }
        }

        updatedControls[index].value = value;
        setControls(updatedControls);
    };

    const searchDistributor = (event) => {
        event.preventDefault();
        setPage(1);
        fetchTid();
    };

    const resetFilter = () => {
        const reset = filterForm.map((filter) => ({ ...filter, value: "" }));
        setControls(reset);
        setPage(1);
        fetchTid(reset);
    };

    const handleSort = (field) => {
        if (sortBy === field) {
            setSortDirection((prev) => (prev === "ASC" ? "DESC" : "ASC"));
        } else {
            setSortBy(field);
            setSortDirection("DESC");
        }
    };

    const fetchTid = (customControls = controls) => {
        setLoading(true);

        const successHandler = (res) => {
            const rawData = res?.data?.data?.content || [];
            const formattedData = rawData
                .filter((item) => !item.deleted)
                .map((item, index) => ({
                    id: item.id || index,
                    tid: item.tid,
                    orgCode: item.orgCode,
                    active: item.active,
                    createdAt: item.createdAt,
                    updatedAt: item.updatedAt,
                }));

            setData(formattedData);
            setTotalPages(res?.data?.data?.totalPages || 1);
            setLoading(false);
        };

        const errorHandler = (err) => {
            toast.error(
                err?.response?.data?.msg ||
                err?.response?.data?.message ||
                err?.message ||
                "Something went wrong"
            );
        };

        const api = new ApiRequest("", successHandler, errorHandler, false);

        const params = getParams(customControls);

        const isFilterApplied =
            params?.tid ||
            params?.orgCode ||
            (params?.active !== "" && params?.active !== undefined);

        if (!isFilterApplied) {
            return api.get(
                `${config.apis.admin.TID_WHITELISTING}active/?page=${page - 1}&size=${size}&sortBy=${sortBy}&sortDirection=${sortDirection}`
            );
        }

        const activeValue =
            typeof params?.active === "object"
                ? params.active.value
                : params?.active;

        const payload = {
            tid: params?.tid || "",
            orgCode: params?.orgCode || "",
            isActive:
                activeValue === "true"
                    ? true
                    : activeValue === "false"
                        ? false
                        : null,
            page: page - 1,
            size,
            sortBy,
            sortDirection,
            isDeleted: false,
        };
        setDownloadPayload(payload);
        return api.post(
            `${config.apis.admin.TID_WHITELISTING}search`,
            payload
        );
    };

    useEffect(() => {
        fetchTid();
    }, [page, size, sortBy, sortDirection, refresh]);

    const formatDate = (date) =>
        date ? new Date(date).toLocaleString() : "Null";

    const handleEditClick = (item) => {
        setSelectedItem(item);
        setEditLimitReached({ tid: false, orgCode: false });
        setShowEditModal(true);
    };

    const updateTid = (values, setErrors) => {
        const successHandler = (res) => {
            if (String(res?.code) === "0000") {
                toast.success("TID updated successfully!");
                setShowEditModal(false);
                fetchTid();
            } else {
                toast.error(res?.msg || "Update failed");
            }
        };

        const errorHandler = (err) => {
            const fieldErrors = err?.response?.data?.fieldErrors;

            if (fieldErrors?.length) {
                const formatted = {};
                fieldErrors.forEach(e => {
                    formatted[e.field] = e.message;
                });
                setErrors(formatted);
                toast.error(fieldErrors[0]?.message);
                return;
            }

            toast.error(err?.message || "Update failed");
        };

        const api = new ApiRequest("", successHandler, errorHandler, false);

        api.put(
            `${config.apis.admin.TID_WHITELISTING}${selectedItem.id}`,
            {
                tid: values.tid,
                orgCode: values.orgCode,
                isActive: values.active,
            }
        );
    };

    const handleDeleteClick = (item) => {
        setSelectedItem(item);
        setShowDeleteModal(true);
    };

    const handleDelete = () => {
        const successHandler = (res) => {

            if (String(res?.code) === "0000") {
                toast.success("TID deleted successfully!");
                setShowDeleteModal(false);
                fetchTid();
            } else {
                toast.error(res?.msg || res?.message || "Failed to delete TID");
            }
        };

        const errorHandler = (err) => {
            toast.error(
                err?.data?.msg ||
                err?.response?.data?.msg ||
                err?.message ||
                "Delete failed"
            );
        };

        const api = new ApiRequest("", successHandler, errorHandler, false);

        api.delete(
            `${config.apis.admin.TID_WHITELISTING}${selectedItem.id}`
        );
    };

    return (
        <div>
            <ToastContainer position="top-right" autoClose={4000} />
            <FilterWrapper>
                <FilterBox
                    filterForm={controls}
                    onFilterChange={FilterChangeHandler}
                    onFilterSubmit={searchDistributor}
                    refreshPage={resetFilter}
                />
            </FilterWrapper>

            <TableWarpper className="mt24">
                {loading ? (
                    <Box display="flex" justifyContent="center" py={5}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <table className="table" style={{ textTransform: "uppercase" }}>
                        <thead>
                            <tr>
                                <th>TID</th>
                                <th>Org Code</th>

                                <th
                                    onClick={() => handleSort("createdAt")}
                                    style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                                >
                                    Created At{" "}
                                    {sortBy === "createdAt"
                                        ? sortDirection === "ASC"
                                            ? "▲"
                                            : "▼"
                                        : "⇅"}
                                </th>

                                <th
                                    onClick={() => handleSort("updatedAt")}
                                    style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                                >
                                    Updated At{" "}
                                    {sortBy === "updatedAt"
                                        ? sortDirection === "ASC"
                                            ? "▲"
                                            : "▼"
                                        : "⇅"}
                                </th>

                                <th>Status</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data.length > 0 ? (
                                data.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.tid}</td>
                                        <td>{item.orgCode}</td>
                                        <td>{formatDate(item.createdAt)}</td>
                                        <td>{formatDate(item.updatedAt)}</td>
                                        <td>
                                            {item.active ? (
                                                <span style={{ color: "green" }}>ACTIVE</span>
                                            ) : (
                                                <span style={{ color: "red" }}>INACTIVE</span>
                                            )}
                                        </td>
                                        <td>
                                            <button
                                                onClick={() => handleEditClick(item)}
                                                style={{ background: "none", border: "none", cursor: "pointer", paddingLeft: "3px" }}
                                            >
                                                <IconEdit />
                                            </button>
                                        </td>
                                        <td><button onClick={() => handleDeleteClick(item)}
                                            style={{ background: "none", border: "none", cursor: "pointer", paddingLeft: "15px" }}>
                                            <img src={IcondDelete} width={20} alt="delete" />
                                        </button></td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                                        <Text size="sm" color="color4">
                                            No data found
                                        </Text>
                                    </td>
                                </tr>
                            )}
                        </tbody>

                        <tfoot>
                            <tr>
                                <td colSpan="6">
                                    <Box display="flex" alignItems="center" mt={2} sx={{ paddingLeft: 2 }}>
                                        <FormControl variant="standard" sx={{ minWidth: 100 }}>
                                            <InputLabel>Items</InputLabel>
                                            <Select
                                                value={size}
                                                onChange={(e) =>
                                                    setSize(Number(e.target.value))
                                                }
                                            >
                                                <MenuItem value={5}>5</MenuItem>
                                                <MenuItem value={10}>10</MenuItem>
                                                <MenuItem value={20}>20</MenuItem>
                                                <MenuItem value={50}>50</MenuItem>
                                            </Select>
                                        </FormControl>

                                        <Pagination
                                            totalPages={totalPages}
                                            currentPage={page}
                                            getCurrentPageData={(curPage) =>
                                                setPage(curPage)
                                            }
                                        />
                                    </Box>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                )}
                <Modal
                    isOpen={showEditModal}
                    style={customStyles}
                    onRequestClose={() => setShowEditModal(false)}
                >
                    <div style={{ width: "400px" }}>
                        <Heading size="lg" color="color2">
                            Edit TID
                        </Heading>

                        <Formik
                            enableReinitialize
                            initialValues={{
                                tid: selectedItem?.tid || "",
                                orgCode: selectedItem?.orgCode || "",
                                active: selectedItem?.active ?? true,
                            }}
                            validationSchema={editValidationSchema}
                            onSubmit={(values, { setErrors }) => {
                                updateTid(values, setErrors);
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                setFieldValue,
                            }) => (
                                <Form>
                                    <div style={{ marginTop: "20px" }}>

                                        <TextField
                                            fullWidth
                                            label="TID"
                                            name="tid"
                                            margin="normal"
                                            value={values.tid}
                                            inputProps={{ maxLength: 50 }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];

                                                if (values.tid.length >= 50 && !allowedKeys.includes(e.key)) {
                                                    e.preventDefault();
                                                    setEditLimitReached(prev => ({ ...prev, tid: true }));
                                                }
                                            }}
                                            onChange={(e) => {
                                                handleChange(e);
                                                setEditLimitReached(prev => ({ ...prev, tid: false }));
                                            }}
                                            onBlur={handleBlur}
                                            error={
                                                (touched.tid && Boolean(errors.tid)) ||
                                                editLimitReached.tid
                                            }
                                            helperText={
                                                editLimitReached.tid
                                                    ? "Maximum 50 characters reached"
                                                    : touched.tid && errors.tid
                                                        ? errors.tid
                                                        : `${values.tid.length}/50 characters`
                                            }
                                        />
                                        <TextField
                                            fullWidth
                                            label="Org Code"
                                            name="orgCode"
                                            margin="normal"
                                            value={values.orgCode}
                                            inputProps={{ maxLength: 50 }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];

                                                if (values.orgCode.length >= 50 && !allowedKeys.includes(e.key)) {
                                                    e.preventDefault();
                                                    setEditLimitReached(prev => ({ ...prev, orgCode: true }));
                                                }
                                            }}
                                            onChange={(e) => {
                                                handleChange(e);
                                                setEditLimitReached(prev => ({ ...prev, orgCode: false }));
                                            }}
                                            onBlur={handleBlur}
                                            error={
                                                (touched.orgCode && Boolean(errors.orgCode)) ||
                                                editLimitReached.orgCode
                                            }
                                            helperText={
                                                editLimitReached.orgCode
                                                    ? "Maximum 50 characters reached"
                                                    : touched.orgCode && errors.orgCode
                                                        ? errors.orgCode
                                                        : `${values.orgCode.length}/50 characters`
                                            }
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={values.active}
                                                    onChange={(e) =>
                                                        setFieldValue("active", e.target.checked)
                                                    }
                                                />
                                            }
                                            label={values.active ? "Active" : "Inactive"}
                                        />
                                    </div>

                                    <div
                                        className="flex flex-end gap4"
                                        style={{ marginTop: "10px", justifyContent: "space-between" }}
                                    >
                                        <ButtonSolid primary type="submit" style={{ padding: "10px" }}>
                                            Save
                                        </ButtonSolid>

                                        <ButtonOutline
                                            style={{ padding: "10px" }}
                                            onClick={() => {
                                                setShowEditModal(false);
                                                setEditLimitReached({ tid: false, orgCode: false });
                                            }}
                                        >
                                            Cancel
                                        </ButtonOutline>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </Modal>
                <Modal
                    isOpen={showDeleteModal}
                    style={customStyles}
                    onRequestClose={() => setShowDeleteModal(false)}
                >
                    <div style={{ width: "350px", textAlign: "center" }}>
                        <Heading size="lg" color="color2">
                            Delete TID
                        </Heading>

                        <Text size="md" style={{ marginTop: "12px" }} color="color2">
                            Are you sure you want to delete this record?
                        </Text>

                        <div
                            className="flex flex-center gap12"
                            style={{ marginTop: "10px", justifyContent: "space-between" }}
                        >
                            <ButtonSolid onClick={handleDelete}
                                style={{
                                    padding: "6px 14px",
                                    borderRadius: "4px",
                                    border: "none",
                                    background: "#ED141F",
                                    color: "#fff",
                                    cursor: "pointer",
                                }}>
                                Delete
                            </ButtonSolid>
                            <ButtonOutline onClick={() => setShowDeleteModal(false)}
                                style={{
                                    padding: "6px 14px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    background: "#fff",
                                    cursor: "pointer",
                                }}>
                                Cancel
                            </ButtonOutline>
                        </div>
                    </div>
                </Modal>
            </TableWarpper>
        </div>
    );
}

export default TidWhitelistingTable;
